import React from 'react';

interface Props {
  dpe: string;
  shape?: 'square'|'rounded';
  size?: 'sm'|'md'|'lg';
}

function Dpe({ dpe, shape = 'square', size = 'sm' }: Props): React.JSX.Element {
  let dpeColor: string;
  switch (dpe) {
  case 'A':
    dpeColor = 'bg-green-500';
    break;
  case 'B':
    dpeColor = 'bg-green-400';
    break;
  case 'C':
    dpeColor = 'bg-green-300';
    break;
  case 'D':
    dpeColor = 'bg-yellow-400';
    break;
  case 'E':
    dpeColor = 'bg-orange-400';
    break;
  case 'F':
    dpeColor = 'bg-orange-500';
    break;
  case 'G':
    dpeColor = 'bg-red-500';
    break;
  default:
    dpeColor = 'bg-gray-500';
  }

  let shapeCSS = 'rounded-md';
  if (shape === 'rounded') {
    shapeCSS = 'rounded-full';
  }

  let sizeCSS = '';
  if (size === 'sm') {
    sizeCSS = 'w-6 h-6 text-xs flex items-center justify-center';
  } else if (size === 'md') {
    sizeCSS = 'w-8 h-8 text-sm flex items-center justify-center';
  } else if (size === 'lg') {
    sizeCSS = 'w-10 h-10 text-xl flex items-center justify-center';
  }

  // base Badge css
  const style = `inline-flex items-center justify-center bg-gray-50 text-white font-medium shadow ${dpeColor} ${shapeCSS} ${sizeCSS}`;

  return (
    <div className={style}>
      {dpe}
    </div>
  );
}

export { Dpe }; 